<template>
  <div>
    <div ref="chartContainer" style="width: 100%; height: 400px;;margin-bottom: 20px" />
  </div>
</template>
<script>
import echarts from 'echarts'

export default {
  name: 'SpinsConsumeAct',
  data() {
    return {

    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '消耗明细'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['收集活动', '锦标赛', '连环礼包'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '收集活动',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '锦标赛',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '连环礼包',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    refresh(data) {
      this.option.xAxis.data = data.date
      this.option.series[0].data = data.collect_spin
      this.option.series[1].data = data.rank_spin
      this.option.series[2].data = data.serial_pack
      this.chart.setOption(this.option, true)
    }
  }
}
</script>

<style scoped>

</style>
